<script setup>
import { useMenuStore } from "~/stores/menu";
import { useSettingsStore } from "~/stores/settings";

const settingsStore = useSettingsStore();
const menuStore = useMenuStore();

const settings = settingsStore.settings;

const menuGridCols = computed(() => {
  return settings.general_menu_mobile.length + 1;
});
</script>

<template>
  <!-- Menu Mobile -->
  <div class="z-30 grid h-14 border-t border-brand-separator bg-brand-sidebar text-white xl:hidden"
    :style="{ gridTemplateColumns: `repeat(${menuGridCols}, minmax(0, 1fr))` }">
    <MenuMobileItem @click="menuStore.toggle()" :class="{ 'pointer-events-none': menuStore.menuOpened }">
      <NuxtLink class="flex h-full flex-col items-center justify-center gap-1 text-center text-gray-400">
        <div class="flex flex-col items-center justify-center h-5">
          <div class="mt-1 h-[1px] w-4 bg-[currentColor] duration-300" :class="{ 'top-rotate': menuStore.menuOpened }">
          </div>
          <div class="my-1 h-[1px] w-4 bg-[currentColor] duration-300" :class="{ 'move-x': menuStore.menuOpened }">
          </div>
          <div class="h-[1px] w-4 bg-[currentColor] duration-300" :class="{ 'bottom-rotate': menuStore.menuOpened }">
          </div>

          <Icon v-if="false" :name="menuStore.menuOpened
            ? 'ic:twotone-close'
            : 'streamline:interface-setting-menu-1-button-parallel-horizontal-lines-menu-navigation-three-hamburger'
            " size="20" />
        </div>
        <MenuMobileText class="text-gray-400">{{
          !menuStore.menuOpened ? "Menu" : "Fechar"
        }}
        </MenuMobileText>
      </NuxtLink>
    </MenuMobileItem>
    <template :key="index" v-for="(menu, index) in settings.general_menu_mobile">
      <MenuMobileItem @click="menuStore.modalClose()">
        <NuxtLink active-class="text-white" :to="menu.link"
          class="flex h-full flex-col items-center justify-center gap text-center text-gray-400">
          <div class="flex flex-col items-center justify-center">
            <Icon :name="menu.icon" size="20" />
          </div>
          <MenuMobileText class="mt-1">{{ menu.title }}</MenuMobileText>
        </NuxtLink>
      </MenuMobileItem>
    </template>
  </div>
</template>

<style scoped>
.move-x {
  transform: translateX(30px);
  opacity: 0;
}

.top-rotate {
  transform-origin: center;
  transform: rotateZ(45deg) translateY(6px) translateX(1.5px);
}

.bottom-rotate {
  transform-origin: center;
  transform: rotateZ(-45deg) translateY(-7px) translateX(2px);
}
</style>
